module.exports = __webpack_public_path__ + "img/icon-interval-statistics.490216ac.svg";